import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deleteWebUrl, webUrlQueryKeys } from '../api/webUrls.api';

export function useDeleteWebUrl(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteWebUrl(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: webUrlQueryKeys.all() });
      toast.success('Web URL deleted successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete web URL');
    },
  });
}
